"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _components = require("components");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _news = require("redux/modules/news");

var _Articles = require("./Articles.scss");

var _Articles2 = _interopRequireDefault(_Articles);

var _Articles3 = require("./Articles.ShareLink");

var _Articles4 = _interopRequireDefault(_Articles3);

var _Articles5 = require("./Articles.Content");

var _Articles6 = _interopRequireDefault(_Articles5);

var _Articles7 = require("./Articles.NextPrev");

var _Articles8 = _interopRequireDefault(_Articles7);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Articles = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch,
        params = _ref.params;

    if (__SERVER__) return dispatch((0, _news.loadNewsSinglePost)(params.index));
  },
  defer: function defer(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState,
        params = _ref2.params;

    return dispatch((0, _news.loadNewsSinglePost)(params.index));
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    articles: state.news.articles,
    blog: state.news.blog,
    loaded: state.news.loaded,
    articleSlug: state.news.articleSlug
  };
}, { loadNewsSinglePost: _news.loadNewsSinglePost }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(Articles, _React$Component);

  function Articles() {
    (0, _classCallCheck3.default)(this, Articles);
    return (0, _possibleConstructorReturn3.default)(this, (Articles.__proto__ || (0, _getPrototypeOf2.default)(Articles)).apply(this, arguments));
  }

  (0, _createClass3.default)(Articles, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          articles = _props.articles,
          blog = _props.blog,
          params = _props.params,
          loaded = _props.loaded;

      var matchingBlogItem = blog.find(function (item) {
        return item.slug === params.index;
      });

      var _ref3 = (!loaded ? matchingBlogItem : articles) || {},
          title = _ref3.title,
          description = _ref3.description,
          image = _ref3.image,
          content = _ref3.content,
          date = _ref3.date,
          authorName = _ref3.authorName,
          authorImage = _ref3.authorImage,
          next = _ref3.next,
          prev = _ref3.prev;

      if (__SERVER__) {
        return _react2.default.createElement(
          _components.AppSideEffects,
          {
            documentTitle: title,
            documentImage: image,
            documentDescription: description
          },
          _react2.default.createElement("div", { className: _Articles2.default.empty })
        );
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: title,
          documentImage: image,
          documentDescription: description
        },
        _react2.default.createElement(
          "article",
          { className: _Articles2.default.article },
          _react2.default.createElement("img", { className: _Articles2.default.image, src: image || "" }),
          _react2.default.createElement(
            "section",
            { className: _Articles2.default.articleBody },
            date && date ? _react2.default.createElement(
              "header",
              null,
              _react2.default.createElement(
                "h3",
                { className: _Articles2.default.date },
                (0, _utils.prettyDate)(date)
              ),
              _react2.default.createElement(
                "h1",
                null,
                title
              ),
              _react2.default.createElement(
                "ul",
                { className: _Articles2.default.share },
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(_Articles4.default, { type: "facebook" })
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(_Articles4.default, { type: "twitter" })
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(_Articles4.default, { type: "linkedIn" })
                )
              )
            ) : null,
            _react2.default.createElement(
              "div",
              { className: _Articles2.default.content },
              content ? _react2.default.createElement(
                _Articles6.default,
                null,
                content
              ) : _react2.default.createElement(
                "div",
                { className: _Articles2.default.contentPreloader },
                _react2.default.createElement(_Preloader2.default, null)
              )
            ),
            authorName && authorImage ? _react2.default.createElement(
              "footer",
              { className: _Articles2.default.author },
              _react2.default.createElement("img", { alt: authorName + " avatar", src: authorImage }),
              _react2.default.createElement(
                "dl",
                null,
                _react2.default.createElement(
                  "dt",
                  null,
                  "Written By"
                ),
                _react2.default.createElement(
                  "dd",
                  null,
                  authorName
                )
              )
            ) : null
          ),
          prev || next ? _react2.default.createElement(
            "footer",
            null,
            _react2.default.createElement(
              "div",
              {
                className: (0, _classnames3.default)(_Articles2.default.nextPrevWrap, (0, _defineProperty3.default)({}, _Articles2.default.nextPrevWrapSingle, !next != !prev))
              },
              prev ? _react2.default.createElement(
                "div",
                { className: _Articles2.default.nextPrev },
                _react2.default.createElement(
                  "h3",
                  null,
                  "Previous Post"
                ),
                _react2.default.createElement(_Articles8.default, { item: prev })
              ) : null,
              next ? _react2.default.createElement(
                "div",
                { className: _Articles2.default.nextPrev },
                _react2.default.createElement(
                  "h3",
                  null,
                  "Next Post"
                ),
                _react2.default.createElement(_Articles8.default, { item: next })
              ) : null
            ),
            _react2.default.createElement(
              "div",
              { className: _Articles2.default.buttonContainer },
              _react2.default.createElement(_components.TextButtonLibrary, {
                mode: "secondary",
                label: "Back to Blog Index",
                to: "/blog"
              })
            )
          ) : null
        )
      );
    }
  }]);
  return Articles;
}(_react2.default.Component)) || _class) || _class);
exports.default = Articles;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blog/Articles.jsx
// module id = 2968
// module chunks = 0